import { Component, Input } from '@angular/core';
import { DocumentViewerService } from '../../services/document-viewer.service';
import { DocumentManagementService } from '../../services/document-management/document-management.service';
import { AppMainService } from 'src/app/app-main.service';
import { MessageService } from 'primeng/api';
import { Subject, takeUntil } from 'rxjs';
import { ColumnDefinition } from '../../models/dynamic-table/dynamic-table-data.model';

@Component({
  selector: 'app-shared-workbook-cell',
  templateUrl: './shared-workbook-cell.component.html',
  styleUrl: './shared-workbook-cell.component.scss'
})
export class SharedWorkbookCellComponent {
  @Input() col: ColumnDefinition;
  @Input() workbookRow: any;
  /** Subscription and Cleanup */
  protected ngUnsubscribe$: Subject<void> = new Subject<void>();

  /**User Detail pop up */
  displayUserDetails: boolean = false;
  selectedUser: any;

  // File viewer properties
  displayFileDialog: boolean = false;
  displayType: 'files' | 'pics' = 'files';
  displayItems: any[] = [];

  ngOnInit() {
  }
  constructor(
    private readonly appMainService: AppMainService,
    private readonly messageService: MessageService,
    public documentManagementService: DocumentManagementService,
    private readonly documentViewerService: DocumentViewerService,
  ) { }

  //#region Tagged User Details Popup
  openTaggedUserDetails(event, userId: any) {
    event.stopPropagation();
    this.selectedUser = userId;
    this.displayUserDetails = true;
  }
  closeTaggedUserDetails() {
    this.selectedUser = null;
    this.displayUserDetails = false;
  }
  //#endregion Tagged User Details Popup

  // Update file handling methods
  openFiles(event: any, files: any[]) {
    if (event) {
      event.stopPropagation();
    }
    this.displayItems = files;
    this.displayType = 'files';
    this.displayFileDialog = true;
  }

  openPics(event: any, pics: any[]) {
    if (event) {
      event.stopPropagation();
    }
    this.displayItems = pics;
    this.displayType = 'pics';
    this.displayFileDialog = true;
  }

  onDisplayDialogChange(display: boolean) {
    this.displayFileDialog = display;
    if (!display) {
      this.displayItems = [];
    }
  }

  ngOnDestroy(): void {
    if (this.ngUnsubscribe$) {
      this.ngUnsubscribe$.next();
      this.ngUnsubscribe$.complete();
      this.ngUnsubscribe$.unsubscribe();
    }
  }
}
